// extracted by mini-css-extract-plugin
module.exports = {"columns":"columns-module--columns--bdbH8","col50":"columns-module--col50--2Cwxp"};